import {
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const InvestmentPlanFamily = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text: "<br /><h5>Don't delay. Invest now and secure your future.</h5>",
    },
    {
      type: 'cards',
      cards: [
        {
          title: "Plan your child's future",
          returns: '21.5',
          doubledIn: () => {
            const balancedPlan = calculateSipFutureValue(7000, 10, 16);
            return `
            Rs. ${7000} invested every month can become up to Rs. ${formatRupeeLiteral(
              balancedPlan
            )} in 10 years`;
          },
          link: '/save/plan/24',
          linkAmount: 7000,
          highlighted: true,
          planId: 24,
        },
      ],
    },
  ],
};

export default InvestmentPlanFamily;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanFamily.ts